import script from "./UploadIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadIcon.vue?vue&type=script&setup=true&lang=js"

import "./UploadIcon.vue?vue&type=style&index=0&id=d65e26d2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d65e26d2"]])

export default __exports__